import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { FinancialNonpaymentNonfederalModel } from './types';
import { financialNonPaymentItemValidator } from './validators/item';

const financialNonpaymentNonfederalValidator: ValidateJSModel<FinancialNonpaymentNonfederalModel> = {
  HasNonpaymentNonfederal: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasNonpaymentNonfederal?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialNonPaymentItemValidator },
      };
    }

    return {};
  },
};

export default financialNonpaymentNonfederalValidator;
